(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.ccar').forEach(function (root) {
      var track = root.querySelector('.ccar__track');
      var prev = root.querySelector('.ccar__btn--prev');
      var next = root.querySelector('.ccar__btn--next');
      if (!track || !prev || !next) return;

      function update() {
        var max = track.scrollWidth - track.clientWidth - 1;
        prev.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft >= max;
      }
      function step(dir) {
        var slide = track.querySelector('.ccar__slide');
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        var w = slide ? slide.getBoundingClientRect().width + gap : 200;
        var visible = Math.max(1, Math.floor(track.clientWidth / w));
        track.scrollBy({ left: dir * w * visible, behavior: 'smooth' });
      }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fpf-carousel')) {
    class FpfCarousel extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-fpf-scroll]');
        this.prev = this.querySelector('[data-fpf-prev]');
        this.next = this.querySelector('[data-fpf-next]');
        if (!this.scroller) return;

        this.update = this.update.bind(this);
        this.scroller.addEventListener('scroll', this.update, { passive: true });
        if (this.prev) this.prev.addEventListener('click', () => this.move(-1));
        if (this.next) this.next.addEventListener('click', () => this.move(1));

        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.update);
          this.observer.observe(this.scroller);
        }
        this.update();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      move(direction) {
        const cards = this.scroller.querySelectorAll('.fpf__card');
        if (cards.length < 2) return;
        const pitch = cards[1].offsetLeft - cards[0].offsetLeft;
        const styles = getComputedStyle(this.scroller);
        const inner = this.scroller.clientWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
        const gap = pitch - cards[0].offsetWidth;
        const visible = Math.max(1, Math.round((inner + gap) / pitch));
        this.scroller.scrollBy({ left: direction * pitch * visible, behavior: 'smooth' });
      }

      update() {
        const el = this.scroller;
        const max = el.scrollWidth - el.clientWidth;
        el.classList.toggle('is-scrollable', max > 1);
        if (this.prev) this.prev.disabled = el.scrollLeft <= 1;
        if (this.next) this.next.disabled = el.scrollLeft >= max - 1;
      }
    }

    customElements.define('fpf-carousel', FpfCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banners"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.__hb) return; root.__hb = true;
      var slides = [].slice.call(root.querySelectorAll('[data-hb-slide]'));
      var dots = [].slice.call(root.querySelectorAll('[data-hb-dot]'));
      if (!slides.length) return;
      var i = 0, timer = null;
      var interval = parseInt(root.dataset.interval, 10) || 7000;
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      var auto = root.dataset.autoplay !== 'false' && !reduce && slides.length > 1;
      function tone() { root.classList.toggle('hb--dark', slides[i].dataset.tone !== 'light'); root.classList.toggle('hb--light', slides[i].dataset.tone === 'light'); }
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); if (k === i) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true'); });
        dots.forEach(function (d, k) {
          d.setAttribute('aria-selected', k === i ? 'true' : 'false');
          d.classList.remove('is-active'); void d.offsetWidth; if (k === i) d.classList.add('is-active');
        });
        tone(); schedule();
      }
      function schedule() { clearTimeout(timer); if (auto && !root.classList.contains('is-paused')) timer = setTimeout(function () { go(i + 1); }, interval); }
      function pause() { root.classList.add('is-paused'); clearTimeout(timer); }
      function resume() { root.classList.remove('is-paused'); var d = dots[i]; if (d) { d.classList.remove('is-active'); void d.offsetWidth; d.classList.add('is-active'); } schedule(); }
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.hbDot, 10)); }); });
      var p = root.querySelector('[data-hb-prev]'), n = root.querySelector('[data-hb-next]');
      if (p) p.addEventListener('click', function () { go(i - 1); });
      if (n) n.addEventListener('click', function () { go(i + 1); });
      root.addEventListener('mouseenter', pause); root.addEventListener('mouseleave', resume);
      root.addEventListener('focusin', pause); root.addEventListener('focusout', resume);
      document.addEventListener('visibilitychange', function () { document.hidden ? pause() : resume(); });
      var x0 = null;
      root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); x0 = null; }, { passive: true });
      root.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') go(i - 1); if (e.key === 'ArrowRight') go(i + 1); });
      tone(); schedule();
    }
    function boot() { document.querySelectorAll('[data-hb]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var GIF = /^data:image\/gif/;
    function base(u) { return (u || '').split('?')[0].replace(/^https?:/, '').replace(/_\d+x\d*(?=\.)/, ''); }
    function hydrate(card) {
      card.classList.add('p-test-active');
      card.querySelectorAll('img[data-src]').forEach(function (im) {
        var cur = im.getAttribute('src') || '';
        if (!cur || GIF.test(cur)) { im.src = im.getAttribute('data-src'); }
      });
    }
    function skin(root) {
      var max = parseInt(root.dataset.max, 10) || 40;
      var list = document.getElementById('revieListTestimoniales');
      if (!list) return false;
      var cards = [].slice.call(list.querySelectorAll('.p-test'));
      if (!cards.length) return false;
      var withPhoto = [], without = [];
      cards.forEach(function (c) {
        var d = (c.getAttribute('data-image') || '').trim();
        var pimg = base(c.getAttribute('data-pimg'));
        var has = d && !/sin-fotos/.test(d) && base(d) !== pimg && !/casavinte\.cl\/cdn\/shop|cdn\.shopify\.com/.test(d);
        c.classList.toggle('pr-nophoto', !has);
        (has ? withPhoto : without).push(c);
      });
      var ordered = withPhoto.concat(without);
      ordered.forEach(function (c, k) { c.style.order = k; c.classList.toggle('pr-x', k >= max); if (k < max) hydrate(c); });
      var t = document.querySelector('.sectionRevieWidget4 .topTest');
      var m = t && t.textContent.match(/(\d[\d.,]*)/);
      var num = root.querySelector('[data-pr-count]');
      if (num) num.textContent = m ? m[1] : String(cards.length);
      return true;
    }
    function init(root) {
      if (root.__pr) return; root.__pr = true;
      var tries = 0;
      var wrap = root.closest('.shopify-section');
      var t = setInterval(function () {
        tries++;
        if (skin(root)) { clearInterval(t); watch(root); }
        else if (tries > 48) { clearInterval(t); if (wrap) wrap.style.display = 'none'; var next = wrap && wrap.nextElementSibling; if (next && next.querySelector('.sectionRevieWidget4')) next.style.display = 'none'; }
      }, 250);
      var prev = root.querySelector('[data-pr-prev]'), next2 = root.querySelector('[data-pr-next]');
      function step(dir) { var l = document.getElementById('revieListTestimoniales'); if (!l) return; var c = l.querySelector('.p-test:not(.pr-x)'); var w = c ? c.getBoundingClientRect().width + 20 : 360; l.scrollBy({ left: dir * w * 2, behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next2) next2.addEventListener('click', function () { step(1); });
    }
    function watch(root) {
      var l = document.getElementById('revieListTestimoniales'); if (!l || !window.MutationObserver) return;
      var busy = false;
      new MutationObserver(function () { if (busy) return; busy = true; setTimeout(function () { skin(root); busy = false; }, 300); }).observe(l, { childList: true });
    }
    function boot() { document.querySelectorAll('[data-pr]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-luxe"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MIN_TOTAL = 12;
    var GIF = /^data:image\/gif/;
    function base(u) { return (u || '').split('?')[0].replace(/^https?:/, '').replace(/_\d+x\d*(?=\.)/, ''); }
    function hydrate(card) {
      card.classList.add('p-test-active');
      card.querySelectorAll('img[data-src]').forEach(function (im) {
        var cur = im.getAttribute('src') || '';
        if (!cur || GIF.test(cur)) { im.src = im.getAttribute('data-src'); }
      });
    }
    function skin(root) {
      var max = parseInt(root.dataset.max, 10) || 60;
      var list = document.getElementById('revieListTestimoniales');
      if (!list) return false;
      var cards = [].slice.call(list.querySelectorAll('.p-test'));
      if (!cards.length) return false;
      var withPhoto = [], without = [];
      cards.forEach(function (c) {
        var d = (c.getAttribute('data-image') || '').trim();
        var pimg = base(c.getAttribute('data-pimg'));
        var has = d && !/sin-fotos/.test(d) && base(d) !== pimg && !/casavinte\.cl\/cdn\/shop|cdn\.shopify\.com/.test(d);
        c.classList.toggle('rvl-nophoto', !has);
        (has ? withPhoto : without).push(c);
      });
      var shown = withPhoto.slice(0, max);
      if (shown.length < MIN_TOTAL) shown = shown.concat(without.slice(0, MIN_TOTAL - shown.length));
      var ordered = withPhoto.concat(without);
      ordered.forEach(function (c, k) {
        var on = shown.indexOf(c) !== -1;
        c.style.order = k;
        c.classList.toggle('rvl-x', !on);
        if (on) hydrate(c);
      });
      return true;
    }
    function init(root) {
      if (root.__rvl) return; root.__rvl = true;
      var tries = 0;
      var t = setInterval(function () { tries++; if (skin(root) || tries > 60) { clearInterval(t); watch(root); } }, 250);
      var prev = root.querySelector('[data-rvl-prev]'), next = root.querySelector('[data-rvl-next]');
      function step(dir) { var l = document.getElementById('revieListTestimoniales'); if (!l) return; var c = l.querySelector('.p-test:not(.rvl-x)'); var w = c ? c.getBoundingClientRect().width + 20 : 360; l.scrollBy({ left: dir * w * 2, behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    }
    function watch(root) {
      var l = document.getElementById('revieListTestimoniales'); if (!l || !window.MutationObserver) return;
      var busy = false;
      new MutationObserver(function () { if (busy) return; busy = true; setTimeout(function () { skin(root); busy = false; }, 300); }).observe(l, { childList: true });
    }
    function boot() { document.querySelectorAll('[data-rvl]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
